module.exports = __webpack_public_path__ + "assets/img/yutari-photo02.9cacf22e.jpg";